// extracted by mini-css-extract-plugin
export var closeButton = "_2c-3";
export var header = "_2c-0";
export var link = "_2c-1";
export var retryButton = "_2c-2";